import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Parts, Types, Objects} from "components";

import ObjectOverride from "components/ObjectOverride";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


/**
 *  @property {Acquisitions_Pendings_Object} state
 *  @property {object} model
 *  @property {Acquisitions_Pendings_Properties} model.properties
 *  @property {Acquisitions_Pendings_Is} model.is
 *  @property {Acquisitions_Pendings_Has} model.has
 */
export default class Acquisition extends ObjectOverride {
	constructor(props) {
		super(props, Types.Acquisitions_Pendings._name);

		this.state.transaction_entriess = [];

		this.afterEventSave = this.setNewObject('event');
		this.handleComplete = this.handleComplete.bind(this);
	}

	/**
	 * @param prevProps
	 * @param {Acquisitions_Pendings_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Acquisitions_Pendings_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.ffl_name || object.pkey);
		}

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey) {
			//If "Location" select was updated, update corresponding Location Information
			if (object.location && object.location !== prevState.location) {
				this.setState({'bound_book': ''});
			}
		}
	}

	handleProcess(event, requestOverride) {
		let result = true;
		/** @type {Acquisitions_Pendings_Object} object */
		let object = this.state;
		if (object.acquisition_pending_productss === null || object.acquisition_pending_productss.length === 0) {
			API.Toast.warn('A product is required.', {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
			result = false;
		}

		// if (!this.state.dealer) {
		// 	this.setState({
		// 		dealer_error: 'Dealer is required'
		// 	});
		// 	result = false;
		// }

		//If either is false then fail
		return result && super.handleProcess(event, requestOverride);
	}

	async handleSubmit(event, suppressToast = false) {
		await super.handleSubmit(event, suppressToast);
	};

	async handleComplete(event, suppressToast = false) {
		this.update = 'POST_COMPLETE';
		await super.handleSubmit(event, suppressToast);
	};

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		if (this.update === 'POST_COMPLETE') {
			this.update = 'POST';
			this.props.history.push('/acquisitions/' + data._id);
		}
	}

	form = () => {
		/** @type {Acquisitions_Pendings_Properties} properties */
		let properties = this.model.properties;
		/** @type {Acquisitions_Pendings_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							{object.location ?
								<Parts.SelectBoundBook
									object={object}
									properties={properties}
									shouldLoad={this.state.loaded}
									onSelectUpdate={this.handleSelectPropertyUpdate}
								/> : null}

							<Parts.TransactionDetails
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterEventSave={this.afterEventSave}
							/>

							<h4 className="section-title">Date of Transfer</h4>
							<div className="form-group">
								<Framework.Elements.DateTime
									label={"Transfer Date"}
									property={properties.date}
									value={object.date}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={"col-md"}>
							<h4 className="section-title">Auto Matched Dealer</h4>

							<div className={'form-group'}>
								<div className="row">
									<div className="col-3">
										<span className="input-label">Dealer</span>
										<UniversalModalOverride
											locations={this.props.locations}
											states={this.props.states}
											history={this.props.history}
											id={this.state.id}
											name={"Dealer"}
											object={Objects.Dealer}
											toggle={this.state['modalDealer']}
											afterSave={typeof this.setNewObject === 'function' ? this.setNewObject('dealer') : null}
										/>
									</div>
									<div className="col-9 d-flex">
										<div className={'flex-grow-1'}>
											<Framework.Elements.Select
												shouldLoad={this.state.loaded}
												property={properties.dealer}
												value={object.dealer}
												binary_id={object.dealer_binary_id}
												error={object.dealer_error}
												object={object.dealers}
												update={this.handleSelectPropertyUpdate}
												text={'name_display(ffl|name_trade(ffl|name_company(ffl'}
												nullable={true}
												sort={'name_display|name_trade|name_company'}
												default={{
													value: '',
													label: 'Add New Dealer'
												}}
											/>
										</div>
									</div>
								</div>
							</div>
							<p style={{
								color: "gray",
								padding: "0 4px",
								marginBottom: "19px",
								fontSize: "11px",
								lineHeight: '12px'
							}}>
								Selecting an existing dealer will update the dealer with the information provided below.
								This information came directly from the in-network dealers account and is likely their most
								up-to-date information.
							</p>
							<h4 className="section-title">Dealer Information</h4>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.ffl_name}
											value={object.ffl_name}
											error={object.ffl_name_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.ffl_number}
											value={object.ffl_number}
											error={object.ffl_number_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.Select
											label={"FFL Type"}
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.ffl_type}
											value={object.ffl_type}
											error={object.ffl_type_error}
											object={object.ffl_types}
											text={'type-name'}
											limit={null}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.Select
											label={"FFL Class"}
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.ffl_class}
											value={object.ffl_class}
											error={object.ffl_class_error}
											object={object.ffl_classes}
											text={'class-description'}
											limit={null}
											default={{value: 4, label: "None - Not a SOT"}}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className={"col-md"}>
							<h4 className="section-title">Contact Information</h4>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.phone}
											value={object.phone}
											error={object.phone_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.EmailAddress
											property={properties.email}
											value={object.email}
											error={object.email_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<h4 className="section-title">Address</h4>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.street_1}
											value={object.street_1}
											error={object.street_1_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-12"}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.street_2}
											value={object.street_2}
											error={object.street_2_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.city}
									value={object.city}
									error={object.city_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={"row"}>
								<div className={"col-4"}>
									<div className="form-group">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											update={this.handleSelectPropertyUpdate}
											property={properties.state}
											value={object.state}
											error={object.state_error}
											id={'short'}
											model={Types.States._name}
											nullable={false}
											limit={null}
										/>
									</div>
								</div>
								<div className={"col-8"}>
									<div className="form-group">
										<Framework.Elements.ZipCode
											property={properties.zip}
											value={object.zip}
											error={object.zip_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					{this.noDelete ?
						<Button color="danger" onClick={this.handleDelete}>Delete</Button>
						: ""
					}
					{this.dataIdSave ?
						<Button color="default" data-id={this.dataIdSave} onClick={this.handleSubmit}>Save Changes</Button>
						:
						<Button color="default" onClick={this.handleSubmit}>Save Changes</Button>
					}
					<Button color="primary" onClick={this.handleComplete}>Complete</Button>
				</CardActions>
			</Card>
		)
	}

}
